import { render, staticRenderFns } from "./crmCustomerType.vue?vue&type=template&id=320f76c7&"
import script from "./crmCustomerType.vue?vue&type=script&lang=js&"
export * from "./crmCustomerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('320f76c7')) {
      api.createRecord('320f76c7', component.options)
    } else {
      api.reload('320f76c7', component.options)
    }
    module.hot.accept("./crmCustomerType.vue?vue&type=template&id=320f76c7&", function () {
      api.rerender('320f76c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/CrmSetting/crmCustomerType.vue"
export default component.exports